// @ts-nocheck
/*
 * Port of components/partials/dashboard/manage-agents/AgentAccountSettingsSection.js (218 lines).
 * BYTE-IDENTICAL â€” sub-form used by both CreateAgent + EditAgent for
 * call-centre-admin-only fields (ACL, account type, expiry).
 *
 * Panel branding is NOT here: it lives on the company, and an agent inherits
 * it from the company they are assigned to.
 */
import React, { useEffect, useState } from 'react';
import { Card as ShadCard } from '@/components/ui/card';
import { Button as _ShadButton } from '@/components/ui/button';
import { CalendarDateInput } from '@/components/ui/calendar-inputs';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Container: any = ({ fluid, className, children, ...props }: any) => (
  <div className={_cx(fluid ? 'container-fluid' : 'container', className)} {...props}>
    {children}
  </div>
);
const Row: any = ({ className, children, ...props }: any) => (
  <div className={_cx('row', className)} {...props}>
    {children}
  </div>
);
const _colCls = ({ xs, sm, md, lg, xl }: any) => {
  const parts = [];
  if (md) parts.push(`col-md-${md}`);
  if (lg) parts.push(`col-lg-${lg}`);
  if (xl) parts.push(`col-xl-${xl}`);
  if (sm) parts.push(`col-sm-${sm}`);
  if (xs) parts.push(`col-${xs}`);
  if (!parts.length) parts.push('col');
  return parts.join(' ');
};
const Col: any = ({ xs, sm, md, lg, xl, className, children, ...props }: any) => (
  <div className={_cx(_colCls({ xs, sm, md, lg, xl }), className)} {...props}>
    {children}
  </div>
);
const _btnVariantMap: Record<string, any> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  light: 'outline',
  link: 'link',
};
const _Unused_Button: any = ({ variant, size, className, children, ...props }: any) => {
  let mapped = variant;
  if (typeof variant === 'string') {
    if (variant.startsWith('outline-')) mapped = 'outline';
    else if (_btnVariantMap[variant]) mapped = _btnVariantMap[variant];
    else if (variant.startsWith('btn ')) mapped = 'default';
  }
  return (
    <_ShadButton variant={mapped} size={size} className={className} {...props}>
      {children}
    </_ShadButton>
  );
};
const _Unused_Card: any = ({ className, children, ...props }: any) => (
  <ShadCard className={className} {...props}>
    {children}
  </ShadCard>
);
_Unused_Card.Header = ({ className, children, ...props }: any) => (
  <div className={_cx('card-header', className)} {...props}>
    {children}
  </div>
);
_Unused_Card.Body = ({ className, children, ...props }: any) => (
  <div className={_cx('card-body', className)} {...props}>
    {children}
  </div>
);
_Unused_Card.Title = ({ as: As = 'h5', className, children, ...props }: any) => (
  <As className={_cx('card-title', className)} {...props}>
    {children}
  </As>
);
_Unused_Card.Text = ({ className, children, ...props }: any) => (
  <p className={_cx('card-text', className)} {...props}>
    {children}
  </p>
);
_Unused_Card.Footer = ({ className, children, ...props }: any) => (
  <div className={_cx('card-footer', className)} {...props}>
    {children}
  </div>
);
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('mb-3', className)} {...props}>
    {children}
  </div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label className={_cx('form-label', className)} htmlFor={htmlFor} {...props}>
    {children}
  </label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const cls = _cx('form-control', isInvalid && 'is-invalid', className);
  if (as === 'select')
    return (
      <select className={cls} {...props}>
        {children}
      </select>
    );
  if (as === 'textarea') return <textarea className={cls} {...props} />;
  return <input className={cls} {...props} />;
};
Form.Select = ({ className, children, isInvalid, ...props }: any) => (
  <select
    className={_cx('form-control form-select', isInvalid && 'is-invalid', className)}
    {...props}
  >
    {children}
  </select>
);
Form.Check = ({
  type = 'checkbox',
  label,
  id,
  className,
  inline,
  children,
  ...props
}: any) => (
  <div className={_cx('form-check', inline && 'form-check-inline', className)}>
    <input type={type} id={id} className="form-check-input" {...props} />
    {label !== undefined && (
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
    )}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small className={_cx('form-text', muted && 'text-muted', className)} {...props}>
    {children}
  </small>
);
const Modal: any = ({ show, onHide, size, centered: _c, children, className, ...props }: any) => {
  const sizeCls =
    size === 'sm'
      ? 'sm:max-w-md'
      : size === 'lg'
      ? 'sm:max-w-2xl'
      : size === 'xl'
      ? 'sm:max-w-6xl'
      : '';
  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && onHide?.()}>
      <DialogContent
        className={`${sizeCls} max-h-[90vh] overflow-y-auto ${className || ''}`.trim()}
        {...props}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
Modal.Header = ({ children, closeButton: _cb, className, ...props }: any) => (
  <DialogHeader className={className} {...props}>
    {children}
  </DialogHeader>
);
Modal.Title = ({ children, className, ...props }: any) => (
  <DialogTitle className={className} {...props}>
    {children}
  </DialogTitle>
);
Modal.Body = ({ children, className, ...props }: any) => (
  <div className={`overflow-x-auto ${className || ''}`.trim()} {...props}>
    {children}
  </div>
);
Modal.Footer = ({ children, className, ...props }: any) => (
  <DialogFooter className={className} {...props}>
    {children}
  </DialogFooter>
);
const Table: any = ({
  bordered,
  striped,
  hover,
  responsive: _r,
  className,
  children,
  ...props
}: any) => (
  <table
    className={_cx(
      'table',
      bordered && 'table-bordered',
      striped && 'table-striped',
      hover && 'table-hover',
      className,
    )}
    {...props}
  >
    {children}
  </table>
);
const _TabsCtx = React.createContext<any>({});
const Tabs: any = ({
  activeKey,
  defaultActiveKey,
  onSelect,
  children,
  className,
  ...props
}: any) => {
  const [internalKey, setInternalKey] = React.useState(defaultActiveKey || null);
  const current = activeKey !== undefined ? activeKey : internalKey;
  const handle = (k: any) => {
    if (activeKey === undefined) setInternalKey(k);
    onSelect?.(k);
  };
  const tabs = React.Children.toArray(children).filter(Boolean) as any[];
  if (current === null && tabs.length) {
    setInternalKey(tabs[0]?.props?.eventKey);
  }
  return (
    <_TabsCtx.Provider value={{ current, setKey: handle }}>
      <div className={className} {...props}>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((t: any) => (
            <li key={t.props.eventKey} className="nav-item" role="presentation">
              <button
                type="button"
                className={_cx('nav-link', current === t.props.eventKey && 'active')}
                onClick={() => handle(t.props.eventKey)}
                disabled={t.props.disabled}
              >
                {t.props.title}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {tabs.map((t: any) => (
            <div
              key={t.props.eventKey}
              className={_cx('tab-pane', current === t.props.eventKey && 'active show')}
              style={{ display: current === t.props.eventKey ? undefined : 'none' }}
            >
              {t.props.children}
            </div>
          ))}
        </div>
      </div>
    </_TabsCtx.Provider>
  );
};
const Tab: any = () => null;
const Tooltip: any = ({ children, id: _id, ...props }: any) => (
  <span {...props}>{children}</span>
);
const OverlayTrigger: any = ({ children, overlay, placement: _p, trigger: _t }: any) => {
  let title = '';
  if (overlay?.props?.children) {
    title =
      typeof overlay.props.children === 'string'
        ? overlay.props.children
        : Array.isArray(overlay.props.children)
          ? overlay.props.children.filter((c: any) => typeof c === 'string').join(' ')
          : '';
  }
  return React.cloneElement(children, { title });
};
const Badge: any = ({ bg, pill, className, children, ...props }: any) => (
  <span
    className={_cx('badge', bg && `bg-${bg}`, pill && 'rounded-pill', className)}
    {...props}
  >
    {children}
  </span>
);
const Spinner: any = ({ animation: _a, size, variant, className, ...props }: any) => (
  <span
    className={_cx(
      'spinner-border',
      size === 'sm' && 'spinner-border-sm',
      variant && `text-${variant}`,
      className,
    )}
    role="status"
    aria-hidden="true"
    {...props}
  />
);
import { FaShieldAlt } from 'react-icons/fa';
import { FiShield } from 'react-icons/fi';
import { getApiCall } from '@/service/getApiCall';
import { API_ACL_SETTING_LIST } from '@/service/url';
import { USER_ROLES } from '@/utilities/constant';

export default function AgentAccountSettingsSection({
  selectedACL,
  setSelectedACL,
  accountType,
  setAccountType,
  expiryDate,
  setExpiryDate,
  parentAccountType = '0',
  parentExpiryDate = null,
  labelStyle = {},
  inputStyle = {},
  iconInputStyle = {},
  inputWrapperStyle = {},
  inputIconStyle = {},
  requiredMark = null,
  disableExpiry = false,
  access = 'regular',
}) {
  const [aclSettingList, setAclSettingList] = useState<any[]>([]);
  const targetRole =
    access === 'team_lead' ? USER_ROLES.CALL_CENTRE_TEAM_LEAD : USER_ROLES.CALL_CENTRE_AGENT;

  useEffect(() => {
    getApiCall(
      `${API_ACL_SETTING_LIST}?target_role=${encodeURIComponent(targetRole)}&fields=min`,
      {},
    )
      .then((resp) => setAclSettingList(Array.isArray(resp) ? resp : []))
      .catch(() => setAclSettingList([]));
  }, [targetRole]);

  useEffect(() => {
    if (!aclSettingList.length || selectedACL) return;
    const defaultAcl = aclSettingList.find((acl) => acl.default_for_role === targetRole);
    if (defaultAcl) setSelectedACL(String(defaultAcl.id));
  }, [aclSettingList, selectedACL, setSelectedACL, targetRole]);

  const resolvedParentAccountType = Number(parentAccountType);
  const maxExpiry = parentExpiryDate ? new Date(parentExpiryDate).toISOString().split('T')[0] : undefined;

  return (
    <>
      <div className="d-flex align-items-start gap-2 mb-4 mt-2">
        <span className="agent-form-section-icon">
          <FaShieldAlt size={14} />
        </span>
        <div>
          <p className="agent-form-section__title">Account Settings</p>
          <p className="agent-form-section__subtitle">
            Portal access, ACL, and account configuration for this agent.
          </p>
        </div>
      </div>

      <Row className="g-4">
        <Col md="4">
          <label htmlFor="agentAclSetting" className="form-label agent-form-label" style={labelStyle}>
            ACL Settings
          </label>
          <div style={inputWrapperStyle}>
            <FiShield style={inputIconStyle} />
            <Form.Select
              id="agentAclSetting"
              value={selectedACL}
              onChange={(e) => setSelectedACL(e.target.value)}
              className="form-control"
              style={iconInputStyle}
            >
              <option value="">Select ACL</option>
              {aclSettingList.map((val) => (
                <option key={val.id} value={val.id}>
                  {val.acl_name}
                </option>
              ))}
            </Form.Select>
          </div>
        </Col>

        <Col md="4">
          <label htmlFor="agentAccountType" className="form-label agent-form-label" style={labelStyle}>
            Account Type {requiredMark}
          </label>
          <div style={inputWrapperStyle}>
            <FaShieldAlt style={inputIconStyle} />
            <Form.Select
              id="agentAccountType"
              value={accountType}
              onChange={(e) => setAccountType(e.target.value)}
              className="form-control"
              style={iconInputStyle}
            >
              {Number(resolvedParentAccountType) === 1 ? (
                <option value="1">Transactional</option>
              ) : (
                <option value="0">Promotional</option>
              )}
            </Form.Select>
          </div>
        </Col>

        <Col md="4">
          <label htmlFor="agentExpiryDate" className="form-label agent-form-label" style={labelStyle}>
            Expiry Date {requiredMark}
          </label>
          <CalendarDateInput
            id="agentExpiryDate"
            value={expiryDate || ''}
            onChange={(e) => setExpiryDate(e)}
            max={maxExpiry}
            style={inputStyle}
            disabled={disableExpiry}
          />
          {disableExpiry && (
            <small className="text-muted d-block mt-1">
              Managed automatically for demo company agents (extended on each recharge).
            </small>
          )}
        </Col>

      </Row>
    </>
  );
}

